import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-download-list-item',
  templateUrl: './download-list-item.component.html',
  styleUrls: ['./download-list-item.component.scss']
})
export class DownloadListItemComponent implements OnInit {


  @Input() link = ''
  @Input() text = ''
  @Input() countDetail: number = 0
  @Input() countTopic: any = 1

  isHover = false
  constructor() { }

  setHoverStatus(status) {
    this.isHover = status
  }

  ngOnInit() {
    var ct = localStorage.getItem('countTopic');
    var cd = localStorage.getItem('countDetail');
    if (ct == this.countTopic) {
      this.countDetail = Number(cd) + 1
      localStorage.setItem('countDetail', String(this.countDetail))
    } else {
      localStorage.setItem('countTopic', this.countTopic)
      localStorage.setItem('countDetail', "1")
      this.countDetail = 1
    }
  }

}
